export default __webpack_public_path__ + "8fb8260bc67b19cb4a8f3b03766bb340.svg";